shadow$provide[25] = function(global,require,module,exports) {

};